import { useAuthenticatedUser } from "@/composables/authenticated-user";
import { until } from "@vueuse/core";
import { unref } from "vue";
import { routeNames } from "@/router/names";
import type { RouteLocationNormalized } from "vue-router";

export default async function requireAuth (to: RouteLocationNormalized) {
  // If nothing is matched, then assume no auth is required.
  if (to.matched.length < 1) {
    return false
  }

  // For now, whether auth is required or not is determined by the parent route.
  const { requiresAuth } = to.matched[0].meta

  // No auth is required, so do nothing.
  if (requiresAuth === false) {
    return true
  }

  // Auth is required. Let's check if we're authenticated.
  const { isFetching, data: user } = useAuthenticatedUser()

  // Ensure any in-flight refreshes are finished.
  await until(isFetching).not.toBeTruthy()

  // If there is no user, then redirect to the login page.
  if (unref(user) === undefined) {
    return { name: routeNames.login }
  }
}